import { useState } from "react";

const faqs = [
  { q: "What is the ACBuy Spreadsheet 2026?", a: "The ACBuy Spreadsheet 2026 is a community-curated database of 100,000+ replica products with verified seller links, QC photos, and shipping information. It's the best hipobuy spreadsheet alternative available in 2026." },
  { q: "How is ACBuy Spreadsheet different from hipobuy spreadsheet?", a: "Unlike the hipobuy spreadsheet 2026, ACBuy updates daily, covers more categories, and has advanced QC photo integration. It's widely considered the best hipobuy spreadsheet alternative for 2026." },
  { q: "How do I find hipobuy shipping coupons?", a: "Hipobuy shipping coupons are regularly shared in our community forums. We also track seasonal sales like 11.11 and Black Friday where significant shipping discounts are available." },
  { q: "What is a hipobuy haul and how do I plan one?", a: "A hipobuy haul is ordering multiple items together to save on shipping. Use the ACBuy Spreadsheet 2026 to build your list, check QC photos for each item, then consolidate into one shipment for maximum savings." },
  { q: "How does the hipobuy QC finder work?", a: "The hipobuy QC finder lets you search for quality control photos by product name or item code. It shows real photos taken before shipping so you can verify quality before approving your order." },
  { q: "Are hipobuy sheets still useful in 2026?", a: "Hipobuy sheets are still a useful reference, but the ACBuy Spreadsheet 2026 offers more frequent updates, a larger database, and better QC integration. Most experienced buyers use ACBuy as their primary resource." },
  { q: "How do I use the ACBuy Spreadsheet to find the best deals?", a: "Browse by category or search by brand/product name. Filter by seller rating and check QC photos. Use hipobuy shipping coupons and consolidate orders to minimize shipping costs." },
  { q: "Is the ACBuy Spreadsheet 2026 free?", a: "Yes, the ACBuy Spreadsheet 2026 is completely free to use. Visit repsw2c.com to access the full database with no registration required." },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section className="py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-amber-100 text-amber-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-3">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            ACBuy Spreadsheet FAQ — Everything You Need to Know
          </h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-100 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-amber-50 transition-colors cursor-pointer"
              >
                <span className="text-sm font-semibold text-gray-800 pr-4">{faq.q}</span>
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className={`text-amber-500 transition-transform duration-200 ${open === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 pb-4 bg-amber-50">
                  <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
